import { ref } from 'vue';

const model = ref({
	price: null,
	tax: null,
	capital: null,
	term: 48,
	residualPercentage: 25,
	interestRate: null,
	businessUsagePercentage: 50,
	yieldPercentage: 8,
	captchaKey: null,
	captchaText: null
});
const result = ref({
	leasingComparationList: [],
	calculatedModel: {}
});

export const useStore = () => {
	return { model, result };
};
